import React from 'react';
import './WhatWeDo.scss';
import LinkButton from '../LinkButton/LinkButton';
import { useState } from 'react';
import Brochure from '../Brochure/Brochure';
import Carousel from '../Carousel/Carousel';
// TODO! Rebuild

const WhatWeDo = ({ contentItems, title, subtitle, hideBrochure, singlePage }) => {
	return (
		<div className='what-we-do-container'>
			<h2>{title}</h2>
			<p>{subtitle}</p>
			<div className='row'>
				{typeof contentItems !== 'undefined' &&
					contentItems.length &&
					contentItems.length > 0 &&
					(typeof singlePage ===
						'undefined' || singlePage === false) && (
							<Carousel
								rightVisible
								buttonsVisible
								slideContent={[
									<Slide1 content={contentItems} />,
									<Slide2 content={contentItems} />,
								]}
							/>
						)}
				{typeof singlePage !== 'undefined' && singlePage === true && (
					<Carousel slideContent={[<Slide2 content={contentItems} center={true}/>]} />
				)}
			</div>
			{(typeof hideBrochure === 'undefined' || hideBrochure === false) && (
				<div className='row brochure-container'>
					<Brochure />
				</div>
			)}
		</div>
	);
};

export default WhatWeDo;

const Slide1 = ({ content }) => (
	<React.Fragment>
		<div className='row'>
			{content.map(({ imageAlt, imageSrc, title, text }, i) =>
				i < 4 ? null : (
					<div className={`col-sm-3 col-md-3 wwd-item`} key={i}>
						<img src={imageSrc} alt={imageAlt || title} />
						<h5>{title}</h5>
						<p>{text}</p>
					</div>
				)
			)}
		</div>
	</React.Fragment>
);

const Slide2 = ({ content, center }) => (
	<React.Fragment>
		<div className='row' style={{justifyContent: center ? 'center' : ''}}>
			{content.map(({ imageAlt, imageSrc, title, text, comingSoon }, i) =>
				i >= 4 ? null : (
					<div className={`col-sm-3 col-md-3 wwd-item`} key={i}>
						<img src={imageSrc} alt={imageAlt || title} />
						<h5>{title}</h5>
						<p>{text}</p>
						{typeof comingSoon !== 'undefined' && <p style={{fontStyle:'italic'}}>{comingSoon}</p>}
					</div>
				)
			)}
		</div>
	</React.Fragment>
);
